import React, { createContext, useContext, useEffect, useState } from 'react';
import { initGoogleTranslate, readTranslateCookie, setTranslateCookie } from '../lib/googleTranslate';

const dict = {
  en: {
    'nav.home': 'Home',
    'nav.about': 'About Us',
    'nav.services': 'Services',
    'nav.quote': 'Get Quote',
    'nav.track': 'Track Shipment',
    'nav.office': 'Our Office',
    'nav.contact': 'Contact',
    'company.tagline': 'Global Partner In Movements',
    'iso': 'ISO 9001:2015 Certified',
    'cta.getQuote': 'Get a Quote',
    'cta.trackShipment': 'Track Shipment',
    'cta.contactUs': 'Contact Us',
    'scroll': 'Scroll',
    'hero.slide1.t': 'Possibility In Every Direction', 'hero.slide1.s': 'For us Safety comes first.',
    'hero.slide2.t': 'Global Partner In Movements', 'hero.slide2.s': 'Making you move Ahead',
    'hero.slide3.t': 'Time Effective Movements', 'hero.slide3.s': 'We deliver on time.',
    'hero.slide4.t': 'Each Container Handled Carefully', 'hero.slide4.s': 'For us Safety comes first.',
    'hero.slide5.t': 'Trusted Freight Solutions', 'hero.slide5.s': 'End-to-end supply chain expertise.',
    'about.eyebrow': 'Our Story',
    'about.title': 'ABOUT US',
    'services.eyebrow': 'What We Do',
    'services.title': 'Our Services',
    'team.eyebrow': 'Leadership',
    'team.title': 'Our Team',
    'testimonials.trustedBy': 'Trusted By Leading Brands',
    'testimonials.eyebrow': 'Testimonials',
    'testimonials.title': 'What Our Clients Say',
    'newsletter.title': 'Subscribe to Our Newsletter',
    'newsletter.sub': 'Stay updated with our latest offers, industry news and shipping updates.',
    'newsletter.placeholder': 'Enter your email address',
    'newsletter.button': 'Subscribe',
    'footer.menu': 'Menu',
    'footer.services': 'Our Services',
    'footer.scope': 'Scope of Work',
    'footer.contact': 'Contact Us',
    'footer.address': 'Address:',
    'footer.phone': 'Phone:',
    'footer.email': 'Email:',
    'footer.website': 'Website:',
    'footer.rights': 'ALL RIGHTS RESERVED.',
    'wa.tooltip': 'Chat on WhatsApp',
    'lang.switch': 'Language',
  },
  gu: {
    'nav.home': 'મુખ્ય પૃષ્ઠ',
    'nav.about': 'અમારા વિશે',
    'nav.services': 'સેવાઓ',
    'nav.quote': 'ક્વોટ મેળવો',
    'nav.track': 'શિપમેન્ટ ટ્રેક કરો',
    'nav.office': 'અમારી ઓફિસ',
    'nav.contact': 'સંપર્ક',
    'company.tagline': 'ગ્લોબલ મૂવમેન્ટસમાં સહભાગી',
    'iso': 'ISO 9001:2015 પ્રમાણિત',
    'cta.getQuote': 'ક્વોટ મેળવો',
    'cta.trackShipment': 'શિપમેન્ટ ટ્રેક કરો',
    'cta.contactUs': 'સંપર્ક કરો',
    'scroll': 'સ્ક્રોલ કરો',
    'hero.slide1.t': 'દરેક દિશામાં શક્યતા', 'hero.slide1.s': 'અમારા માટે સુરક્ષા સર્વોપરિ.',
    'hero.slide2.t': 'ગ્લોબલ મૂવમેન્ટસમાં સહભાગી', 'hero.slide2.s': 'તમને આગળ વધારીએ છીએ.',
    'hero.slide3.t': 'સમયસર વાહનવ્યવહાર', 'hero.slide3.s': 'અમે સમયસર ડિલિવરી કરીએ છીએ.',
    'hero.slide4.t': 'દરેક કન્ટેનરનો કાળજીપૂર્વક નિભાવ', 'hero.slide4.s': 'અમારા માટે સુરક્ષા સર્વોપરિ.',
    'hero.slide5.t': 'વિશ્વસનીય ફ્રેટ સોલ્યૂશન્સ', 'hero.slide5.s': 'એન્ડ-ટુ-એન્ડ સપ્લાય ચેન માહિરી.',
    'about.eyebrow': 'અમારી વાર્તા',
    'about.title': 'અમારા વિશે',
    'services.eyebrow': 'અમે શું કરીએ છીએ',
    'services.title': 'અમારી સેવાઓ',
    'team.eyebrow': 'નેતૃત્વ',
    'team.title': 'અમારી ટીમ',
    'testimonials.trustedBy': 'અગ્રણી બ્રાન્ડ દ્વારા વિશ્વસનીય',
    'testimonials.eyebrow': 'પ્રશંસાપત્રો',
    'testimonials.title': 'અમારા ગ્રાહકો શું કહે છે',
    'newsletter.title': 'અમારા ન્યુઝલેટરની સબ્સ્ક્રાઇબ કરો',
    'newsletter.sub': 'અમારા નવા ઑફર, ઉદ્યોગ સમાચાર અને શિપિંગ અપડેટ્સ સાથે અપ-ટુ-ડેટ રહો.',
    'newsletter.placeholder': 'તમારો ઈમેઇલ દાખલ કરો',
    'newsletter.button': 'સબ્સ્ક્રાઇબ',
    'footer.menu': 'મેન્યુ',
    'footer.services': 'અમારી સેવાઓ',
    'footer.scope': 'કાર્ય ક્ષેત્ર',
    'footer.contact': 'સંપર્ક',
    'footer.address': 'સરનામું:',
    'footer.phone': 'ફોન:',
    'footer.email': 'ઈમેઇલ:',
    'footer.website': 'વેબસાઇટ:',
    'footer.rights': 'બધા હક્કો સુરક્ષિત.',
    'wa.tooltip': 'WhatsApp પર ચેટ કરો',
    'lang.switch': 'ભાષા',
  }
};

const LangContext = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });

function getInitialLang() {
  try {
    const saved = localStorage.getItem('vedyah_lang');
    if (saved) return saved;
  } catch { /* storage blocked - fall through */ }
  return readTranslateCookie() || 'en';
}

export function LanguageProvider({ children }) {
  const [lang] = useState(getInitialLang);

  // English and Gujarati use the hand-written texts above; every other language (and the rest of the
  // page content) is translated by Google Translate, which is started here when a non-English language is saved.
  useEffect(() => { initGoogleTranslate(lang); }, [lang]);

  // Switching language = save choice + set translate cookie + reload (most reliable with a React app).
  const setLang = (code) => {
    if (code === lang) return;
    try { localStorage.setItem('vedyah_lang', code); } catch { /* ignore */ }
    setTranslateCookie(code);
    window.location.reload();
  };

  const t = (k) => (dict[lang] && dict[lang][k]) || (dict.en && dict.en[k]) || k;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() { return useContext(LangContext); }
